import { addEmptyOption } from "@/composables/useXsdToFormKit";
import type { LegimatieSoort } from "../HDN/LegimatieSoort";
import type { InventarisationSelectOption } from "./InventarisationSelectOption";

/**
 * Select options for identification type.
 * TODO: indicate which HDN schema version this is from
 */
export const identificationOptions: InventarisationSelectOption<LegimatieSoort>[] =
	addEmptyOption([
		// {
		//   value: "ED Elektronisch Identiteitsbewijs",
		//   label: "Elektronisch Identiteitsbewijs",
		// },
		{
			value: "EI Europese identiteitskaart",
			label: "Europese identiteitskaart",
		},
		{ value: "PP Paspoort", label: "Paspoort" },
		{ value: "RB Rijbewijs", label: "Rijbewijs" },
		{ value: "VI Visum", label: "Visum" },
	]);
